@if(firm?.isDocusignEnabled){
@if(docuSignEditorOpen){
<edit-template (openDocuSignEditor)="openDocuSignEditor($event)" (updateProject)="updateProject()"
    (updateTemplateDocument)="updateTemplateDocument()" [isEditMode]="isEditMode"
    [projectId]="projectId"></edit-template>
} @else {
<div class="grid grid-nogutters">
    <div class="p-0 mb-4 col-12 flex flex-column xl:flex-row gap-3 xl:gap-6">
        <div class="flex align-items-center">
            @if (selectTemplateType === 'New') {
            <p-button label="back" (click)="back()" icon="pi pi-chevron-left" [rounded]="true" size="large" />
            }
        </div>
    </div>
    @if (selectTemplateType === 'New') {
    <div class="p-0 mb-4 col-12 xl:col-6 lg:col-6">
        <div class="grid grid-nogutter">
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class="font-bold white-space-nowrap">
                    {{ 'Upload Documents Description' | sentenceCase }}
                </span>
            </div>

            @if(!selectedDocSignTemplate){
            <div class="col-12 pb-3 pt-0 pr-0 pl-0 mt-3">
                <p-floatLabel>
                    <input id="name" type="text" [(ngModel)]="templateName" [disabled]="selectedDocSignTemplate"
                        required="" pInputText />
                    <label for="name">Template Name</label>
                </p-floatLabel>
            </div>
            }

            <div class="col-12 p-0 flex justify-content-between align-items-center mt-3">
                <p class="m-0 text-sm ">Select .pdf within 50 MB:</p>
                <p-button (click)="uploadFile.click()" label="upload a document" icon="pi pi-plus" size="large"
                    [rounded]="true" />
                <input #uploadFile id="resume" aria-label="resume" type="file" multiple value="..." class="hidden"
                    accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" (change)="uploadDocument($event)">
            </div>
            <div class="mp-uploaded-field" style="width: 60%; align-items: start">
                <ul>
                    @for (fileObject of projectFiles; track fileObject.name) {
                    <li style="text-align: left;">
                        <label class=" mb-0 w-100 " style="display: inline;">{{ fileObject.name }}</label>
                        <i class="icon-file" style="font-size: 18px; display: inline;"></i>
                        <span>
                            <a class="cursor-pointer" ng-click="deleteDocument($index)">
                                <i class="red icon-delete"></i>
                            </a>
                        </span>
                    </li>
                    }
                </ul>
            </div>
        </div>
    </div>

    <div class="p-0 mb-4 col-12">
        <div class="data-table">
            @for(document of templateDocuments; track $index){
            <div class="col-12 lg:col-6 xl:col-6 flex justify-content-between align-items-center px-4 surface-100 border-bottom-1 border-400">
                <span class="text-sm">
                    <p-floatLabel>
                        <input id="username" required="" [(ngModel)]="document.docTitle" type="text" pInputText />
                        <label for="username">Document Name</label>
                    </p-floatLabel>
                </span>
                <div class="actions flex align-items-center">
                    <p-button (click)="viewDocumentForTemplate(document)" [rounded]="true" size="small" plain="true" label="add fields"></p-button>
                    <p-button pTooltip="Delete" tooltipPosition="top" (click)="removeDocument($index)" [rounded]="true"
                        [text]="true" icon="true" plain="true">
                        <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-forever-outlined red"></span>
                    </p-button>
                </div>
            </div>
            }
        </div>
    </div>
    }
    @if (selectTemplateType === 'Existing') {
    <div
        class="p-0 mb-4 col-12 flex justify-content-start lg:justify-content-between flex-column lg:flex-row align-items-start lg:align-items-center gap-3 lg:gap-0 ">
        <p-iconField iconPosition="right">
            <p-inputIcon styleClass="pi pi-search" />
            <input type="text" pInputText placeholder="Search Keywords" [(ngModel)]="docuSearchText"
                (ngModelChange)="searchDocuTemplate()" />
        </p-iconField>

        <p-button label="new template" (click)="addNewTemplate()" icon="pi pi-plus" [rounded]="true" size="large" />
    </div>
    <div class="p-0 mb-4 col-12">
        <div class="data-table">
            @if(this.projectId){
            <p-table #documentTable [value]="documents" dataKey="_id" [tableStyle]="{ 'min-width': '60rem' }"
                [lazy]="true" [paginator]="true" [rows]="2" [totalRecords]="totalDocuSignTemplate"
                [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)" [rows]="10"
                (onLazyLoad)="onLazyLoad($event)" [(selection)]="selectedDocuments"
                (onRowCollapse)="onRowCollapse($event)" autoLayout="true" [scrollable]="true">
                <ng-template pTemplate="header" >
                    <tr>
                        <th style="width: 4rem"><p-tableHeaderCheckbox /></th>
                        <th>
                            Template Name
                        </th>
                        @if (helperService.checkResponsive()) {
                            <th style="width: 10%" alignFrozen="right" pFrozenColumn>
                              <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                            </th>
                            } @else {
                            <th style="width: 10%">
                              <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                            </th>
                        }
                        <ng-template #frozenHeader>
                        Action
                        </ng-template>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" class="border-0" let-document let-expanded="expanded">
                    <tr [pSelectableRow]="document">
                        <td><p-tableCheckbox [value]="document" /></td>
                        <td>
                            {{ document.name }}
                        </td>
                        @if (helperService.checkResponsive()) {
                            <td alignFrozen="right" pFrozenColumn>
                              <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                            </td>
                            } @else {
                            <td class="p-0">
                              <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                            </td>
                            } 
                            <ng-template #frozenData>
                                <div class="flex gap-2">
                                    <p-button styleClass="p-0" pTooltip="Add a Document" tooltipPosition="top"
                                        [rounded]="true" [text]="true" icon="true"
                                        (onClick)="addDocumentInTemplate($event, document)">
                                        <span class="{{helperService.getEnvironmentName()}}-icon icon-add-outlined"></span>
                                    </p-button>
                                    <p-button styleClass="p-0" type="button" pRipple [pRowToggler]="document" [text]="true"
                                        [rounded]="true" [plain]="true" [icon]="
                                                        expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-up'
                                                        " class="row-toggler" />
                                </div>
                            </ng-template>
                    </tr>
                </ng-template>
                <ng-template pTemplate="rowexpansion" let-templates>
                    <tr>
                        <td colspan="7" class="p-0">
                            <div class="inner-wrap p-0">
                                <p-table [value]="templates.documents" dataKey="_id">
                                    <ng-template pTemplate="body" let-documents>
                    <tr>
                        <td class="pl-40">{{ documents.name }}</td>
                        <td class="pr-40" style="width: 10%">
                            <div class="wrap-actions flex align-items-center gap-2">
                                <p-button pTooltip="Edit" tooltipPosition="top"
                                    (click)="editTemplateDocumentView(templates.templateId, documents.documentId, documents.name, templates)"
                                    [rounded]="true" [text]="true" icon="true">
                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                                </p-button>
                                <p-button pTooltip="View/Download" tooltipPosition="top"
                                    (click)="viewDocument(templates.templateId, documents.documentId, documents.name)"
                                    [rounded]="true" [text]="true" icon="true">
                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-visibility-outlined"></span>
                                </p-button>
                                <p-button pTooltip="Delete" tooltipPosition="top" [rounded]="true" [text]="true"
                                    icon="true"
                                    (onClick)="deleteTemplateDocument($event, documents.documentId, templates.templateId, templates)">
                                    <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                                </p-button>
                            </div>
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
        </td>
        </tr>
        </ng-template>
        </p-table>
        }
    </div>
</div>
<div class="p-0 mb-4 col-12 pl-0 lg:pl-4">
    <p class="m-0 text-black-alpha-90">Documents to be added:</p>
    <ul class="chips m-0 flex-column mt-3">
        @for (doc of selectedDocuments; track $index) {
        <li>
            @for(template of doc.documents; track $index) {<p-chip class="mr-5" label="{{template.name }}" />}</li>
        }
    </ul>
</div>
}

</div>


@if(selectTemplateType === 'New'){
<div class="col-6 p-0 flex justify-content-end gap-3">
    <p-button [disabled]="isSaveTemplateInProgress || !projectFiles.length" label="save"
        (click)="onUploadDocumentsNext()" [rounded]="true" size="large" styleClass="freshgreen-background" />
</div>
} @else {
<div class="col-12 p-0 flex justify-content-end gap-3">
    <p-button label="previous" (click)="goToPrevious(0)" [outlined]="true" [rounded]="true" size="large" />
    @if(project?.step !== '7'){
    <p-button label="save" (click)="next('save')" [rounded]="true" size="large" styleClass="freshgreen-background" />
    <p-button label="next" (click)="next('next')" [rounded]="true" size="large" />

    } @else {
    <p-button [disabled]="(selectTemplateType === 'New' && !templateDocuments.length) || isSaveTemplateInProgress"
        [label]="'Save' + (selectTemplateType !== 'New' ? '' : '')" (click)="next('review')" [rounded]="true"
        size="large" styleClass="freshgreen-background" />
    }

</div>
}


<p-dialog [modal]="true" draggable="false" [(visible)]="visibleDocuSignConfirmModal"
    [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" [style]="{ width: '800px' }">

    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <div class="font-bold">
                Documents to be added
            </div>
        </div>
    </ng-template>
    
    <ng-template pTemplate="body">
        <span class="font-normal">
            Is this document required for users who have already been staffed on Project {{project?.codeName}}
        </span>
    </ng-template>

    <ng-template pTemplate="footer">
        <p-button label="no" size="large" [rounded]="true" (onClick)="setDocReqForStaff()" />
        <p-button label="yes" size="large" [rounded]="true" (onClick)="setDocReqForStaff(true)" />
    </ng-template>
</p-dialog>
<p-dialog [modal]="true" draggable="false" [(visible)]="permanentAddconfirmVisible"
    [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" [style]="{ width: '800px' }" class="custom-dialog">
    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center text-center">
            <span class="font-bold" style="white-space: normal;">
                Do you want to permanently add this document to the template or only for this project?
            </span>
        </div>
    </ng-template>
    <div class="p-dialog-content">
        <div class="gap-2 text-center">
            <span *ngFor="let file of templateDocuments" class="file-name">
                {{ file.file.name }}
            </span>
        </div>
        <div class="inline-flex align-items-center justify-content-center text-center mt-3">
            <span class="font-bold" style="white-space: normal;">
                Please click "Yes" to continue. If not, please click "No"
            </span>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button label="no" size="large" [rounded]="true" (onClick)="uploadPermanentDocs()" />
        <p-button label="yes" size="large" [rounded]="true" (onClick)="uploadPermanentDocs(true)" />
    </ng-template>
</p-dialog>
<p-dialog [modal]="true" draggable="false" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }"
    [style]="{ width: '800px' }">

</p-dialog>

<p-dialog [modal]="true" draggable="false" [(visible)]="visibleMultiDocuSignConfirmModal"
    [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" [style]="{ width: '800px' }">

    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <div class="font-bold">
                Documents to be added
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="body">
        <span class="font-normal">
            Is this document required for users who have already been staffed on Project {{project?.codeName}}
        </span>
    </ng-template>
    <ng-template pTemplate="footer">
        <p-button label="no" size="large" [rounded]="true" (onClick)="setMultiDocReqForStaff()" />
        <p-button label="yes" size="large" [rounded]="true" (onClick)="setMultiDocReqForStaff(true)" />
    </ng-template>
</p-dialog>

<p-dialog [modal]="true" draggable="false" [(visible)]="visible" [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }"
    [style]="{ width: '800px' }">

    <ng-template pTemplate="header">
        <div class="inline-flex align-items-center justify-content-center gap-2">
            <span class="font-bold white-space-nowrap">
                {{ 'Upload Documents Description' | sentenceCase }}
            </span>
        </div>
    </ng-template>

    <div class="grid grid-nogutter">
        <div class="col-12 p-0 flex justify-content-between align-items-center mt-3">
            <p class="m-0 text-sm ">Select .pdf within 50 MB:</p>
            <p-button (click)="uploadFile.click()" label="upload a document" icon="pi pi-plus" size="large"
                [rounded]="true" />
            <input #uploadFile id="resume" aria-label="resume" type="file" multiple value="..." class="hidden"
                accept="application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document" (change)="uploadDocument($event)">
        </div>
        <div class="mp-uploaded-field" style="width: 60%; align-items: start">
            <ul>
                @for (fileObject of projectFiles; track $index) {
                <li style="text-align: left;">
                    <label class=" mb-0 w-100 " style="display: inline;">{{ fileObject.name }}</label>
                    <i class="icon-file" style="font-size: 18px; display: inline;"></i>
                    <span>
                        <a class="cursor-pointer" ng-click="deleteDocument($index)">
                            <i class="icon-delete"></i>
                        </a>
                    </span>
                </li>
                }
            </ul>
        </div>
        <div class="col-12 pb-3 pt-0 pr-0 pl-0 mt-3">
            <p-floatLabel>
                <input id="username" required="" [(ngModel)]="docTitle" type="text" pInputText />
                <label for="username">Display Name<span class="required">*</span></label>
            </p-floatLabel>
            @if (docTitleRequired) {
            <div class="error-txt-new">This is required.</div>
            }
        </div>
    </div>

    <ng-template pTemplate="footer">
        <p-button [disabled]="isSaveTemplateInProgress" label="save" size="large" [rounded]="true"
            styleClass="freshgreen-background" (onClick)="onUploadDocumentsNext()" />
    </ng-template>
</p-dialog>

}

} @else {
<div class="grid grid-nogutters">
    <div
        class="p-0 mb-4 col-12 flex justify-content-start lg:justify-content-between flex-column lg:flex-row align-items-start lg:align-items-center gap-3 lg:gap-0 ">
        <p-button label="upload a document" (click)="showResumeDialog()" icon="pi pi-plus" [rounded]="true"
            size="large" />
    </div>
</div>

<p-table [value]="reviewDocuments" dataKey="_id" [tableStyle]="{ 'min-width': '60rem' }"
    [expandedRowKeys]="expandedRows" (onRowExpand)="onRowExpand($event)" [(selection)]="selectedDocuments"
    (onRowCollapse)="onRowCollapse($event)" autoLayout="true" [scrollable]="true">
    <ng-template pTemplate="header">
        <tr>
            <th>
                Title
            </th>
            <th>
                Instructions
            </th>
            @if (helperService.checkResponsive()) {
                <th style="width: 10%" alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
                } @else {
                <th style="width: 10%">
                  <ng-container *ngTemplateOutlet="frozenHeader"></ng-container>
                </th>
            }
            <ng-template #frozenHeader>
            Action
            </ng-template>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" class="border-0" let-documents let-expanded="expanded">
        <tr>
            <td>
                {{ documents.docTitle }}
            </td>
            <td>
                {{ documents.userTitle || '' }}
            </td>
            @if (helperService.checkResponsive()) {
                <td alignFrozen="right" pFrozenColumn>
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } @else {
                <td >
                  <ng-container *ngTemplateOutlet="frozenData"></ng-container>
                </td>
                } 
                <ng-template #frozenData>
                    <div class="flex gap-2">
                        <p-button [rounded]="true" [text]="true" icon="true" (click)="showEditResumeDialog(documents)">
                            <span class="{{helperService.getEnvironmentName()}}-icon icon-edit-outlined"></span>
                        </p-button>
                        <p-button [rounded]="true" [text]="true" icon="true"
                            (click)="deleteDocument($event, documents._id)">
                            <span class="{{helperService.getEnvironmentName()}}-icon icon-delete-outlined red"></span>
                        </p-button>
                    </div>
                </ng-template>
        </tr>
    </ng-template>
</p-table>
<div class="col-12 p-0 flex justify-content-end gap-3 mt-3">
    <p-button label="previous" (click)="goToPrevious(0)" [outlined]="true" [rounded]="true" size="large" />
    @if(project?.step !== '7'){
    <p-button label="save" (click)="next('save')" [rounded]="true" size="large" styleClass="freshgreen-background" />
    <p-button label="next" (click)="next('next')" [rounded]="true" size="large" />

    } @else {
    <p-button label="save" (click)="next('review')" [rounded]="true" size="large" styleClass="freshgreen-background" />
    }
</div>

<form [formGroup]="resumeDocumentForm">
    <p-dialog [modal]="true" draggable="false" [(visible)]="visibleResumeDialog"
        [breakpoints]="{ '1199px': '75vw', '767px': '90vw' }" [style]="{ width: '30vw' }">

        <ng-template pTemplate="header">
            <div class="inline-flex align-items-center justify-content-center gap-2">
                <span class="font-bold white-space-nowrap">
                    {{'Upload Project Document' | sentenceCase}}
                </span>
            </div>
        </ng-template>

        @if(!isEditResumeDocument){
            @if(firm?.documentsReadOnly){
            <div class="col-12 p-0 mt-3 flex gap-4">
                <div class="flex align-items-center gap-2">
                    <p-radioButton inputId="readOnlyDocumentTypeDoc" name="readOnlyDocumentType" value="DOCUMENT"
                        [(ngModel)]="readOnlyDocumentType" [ngModelOptions]="{standalone: true}" />
                    <label for="readOnlyDocumentTypeDoc">Document</label>
                </div>
                <div class="flex align-items-center gap-2">
                    <p-radioButton inputId="readOnlyDocumentTypeLink" name="readOnlyDocumentType" value="LINK"
                        [(ngModel)]="readOnlyDocumentType" [ngModelOptions]="{standalone: true}" />
                    <label for="readOnlyDocumentTypeLink">Link</label>
                </div>
            </div>
            }

        <div class="grid grid-nogutter">
            @if(!firm?.documentsReadOnly || readOnlyDocumentType === 'DOCUMENT'){
            <div class="col-12 p-0 flex justify-content-between align-items-center mt-3">
                <p-button (click)="uploadResume.click()" [label]="fileName" icon="pi pi-plus" size="large"
                    [rounded]="true" class="file-name-wrap" />
                <input #uploadResume id="resume" type="file" class="hidden" value="..." name="file" accept="image/*,text/plain,application/pdf,application/msword,
                                        application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                        application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
                                        ,.doc,.docx,.xls,.xlsx,.txt" button-disable
                    (change)="uploadResumeDocument($event)">
            </div>
            @if(showResumeDocUploadError){
                <div class="p-error ">{{showResumeDocUploadError}}</div>
            }
            } @else {
            <div class="col-12 p-0 mt-3">
                <p-floatLabel>
                    <input pInputText id="url" formControlName="url" placeholder="https://example.com/document" />
                    <label for="url">URL<span class="required">*</span></label>
                </p-floatLabel>
            </div>
            }
        </div>
        }

        @if(isEditResumeDocument && firm?.documentsReadOnly && readOnlyDocumentType === 'LINK'){
        <div class="col-12 p-0 mt-3">
            <p-floatLabel>
                <input pInputText id="editUrl" formControlName="url" placeholder="https://example.com/document" />
                <label for="editUrl">URL<span class="required">*</span></label>
            </p-floatLabel>
        </div>
        }
        <div class="">
            <div class="col-12 p-0 mt-3">
                <p-floatLabel>
                    <input pInputText id="title" formControlName="docTitle" placeholder="Place your title here" />
                    <label for="title">Title<span class="required">*</span></label>
                </p-floatLabel>
                @if(resumeForm['docTitle'].dirty || resumeForm['docTitle'].touched){
                    @if(resumeForm['docTitle'].errors?.['required']){
                        <div class="p-error ">This is required.</div>
                    }
                }
            </div>
        </div>

        <div class="">
            <div class="col-12 p-0 mt-3">
                <p-floatLabel>
                    <textarea rows="5" cols="30" pInputTextarea formControlName="instructions"
                        placeholder="Place your instructions here">
                        </textarea>
                    <label for="username">{{'Instructions for Candidates.' | sentenceCase}}</label>
                </p-floatLabel>

            </div>
        </div>

        <ng-template pTemplate="footer">
            @if(isEditResumeDocument){
            <p-button [disabled]="isSaveTemplateInProgress" type="submit" label="save" size="large" [rounded]="true"
                (onClick)="updateResumeDocumentAndNext()" styleClass="freshgreen-background" />
            } @else {
            <p-button [disabled]="isSaveTemplateInProgress" type="submit" label="save" size="large" [rounded]="true"
                (onClick)="saveResumeDocumentAndNext()" styleClass="freshgreen-background" />
            }
        </ng-template>
    </p-dialog>
</form>
}